export default __webpack_public_path__ + "static/media/TrueOrFalse.af51dec9.svg";